module.exports = __webpack_public_path__ + "static/media/dance.72726cc9.png";